import { SxProps, Theme } from '@mui/material';

export const getSx = (...sx: SxProps<Theme>[]): SxProps<Theme> => {
  let returnSx = {};
  sx.forEach(sxItem => {
    returnSx = {
      ...returnSx,
      ...sxItem,
    };
  });

  return returnSx;
};
